var tenderView = angular.module('tenderView', [
    'commons.app',
    'ngAnimate',
    'vAccordion',
    'uuid4',
    'angular-md5',
    'ui.router'
]);